import React from "react";
import InstructionRouter from './Instruction/Router';
export { getFields, getReplyFields } from './Instruction/Router';

export default function InstructionPmRouter(props) {
    return (
        <InstructionRouter {...props} mode='PM' />
    );
};
